import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hasNoPermissionDescription: {
		id: 'polaris-ideas.idea-view.sections.deliver.no-permission.has-no-permission-description',
		defaultMessage: "You don't have permission to view linked delivery tickets for this idea.",
		description: "Description displayed when user doesn't have permissions to view JSW tickets",
	},
});
